import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7000Model } from '../kymw7000.model';
// import { TagInfo } from '../vo/tag-info.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

// レスポンス構造
interface GetFeatureThemaResponse {
  Memo: string;
  PlannerSelectionFlag: string;
  ApprovalFlowType: string;
}

/**
 * 特集情報取得サービス
 * @export GetFeatureThemaService
 * @class GetFeatureThemaService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetFeatureThemaService extends PlessJsonResponderSub<GetFeatureThemaResponse> {
  model: KYMW7000Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetFeatureThemaService
   */
  private getBody(): PlessRequest {
    const searchObj = {
      GetFeatureThema: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode
        }
      }
    }

    return new PlessRequest({ search: searchObj });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetFeatureThemaService
   */
  execute(model: KYMW7000Model, f?: () => void): void {
    this.model = model;
    if (f) this.calbak = f;
    this.send('KYMW70getFeatureThema', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetFeatureThemaService
   */
  success(data: GetFeatureThemaResponse) {
    this.model.featureMemo = data[0].Memo;
    this.model.plannerSelectionFlag = data[0].PlannerSelectionFlag;
    this.model.approvalFlowType = data[0].ApprovalFlowType;
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    super.plessErrorHandler(errList);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
